import { Channel, HomePageBannerType } from "core/codegen/types";
export var hardCodedbanners = {
    vtmgo: {
        backgroundColor: null,
        description: "Kijk live of uitgesteld in een handige gratis app.",
        image: {
            __typename: "Image",
            id: 123,
            urls: {
                webp: "/images/banner/vtm-go-default-2024.webp",
                jpeg: "/images/banner/vtm-go-default-2024.jpg",
            },
            x: 0.5,
            y: 0.5,
        },
        mobileImage: {
            __typename: "Image",
            id: 123,
            urls: {
                webp: "/images/banner/vtm-go-default-mobile-2024.webp",
                jpeg: "/images/banner/vtm-go-default-mobile-2024.jpg",
            },
            x: 0.5,
            y: 0.5,
        },
        title: "Alles van VTM en meer",
        uuid: "default-vtmgo",
        cta: {
            url: "https://www.vtmgo.be",
            label: "Kijk op",
        },
        bannerType: HomePageBannerType.DefaultVtmGo,
    },
    vtmgoPlus: {
        backgroundColor: null,
        title: "Spoiler alert: kijk jouw favoriete programma’s vooruit!",
        description: "En dat zonder reclame!",
        uuid: "default-vtmgo-plus",
        cta: {
            label: "Ontdek",
            url: "https://www.vtmgo.be/ontdek",
        },
        mobileImage: {
            __typename: "Image",
            id: 123,
            urls: {
                webp: "/images/banner/vtm-go-plus-mobile-2024.webp",
                jpeg: "/images/banner/vtm-go-plus-mobile-2024.jpg",
            },
            x: 0.5,
            y: 0.5,
        },
        image: {
            __typename: "Image",
            id: 123,
            urls: {
                webp: "/images/banner/vtm-go-plus-2024.webp",
                jpeg: "/images/banner/vtm-go-plus-2024.jpg",
            },
            x: 0.5,
            y: 0.5,
        },
        bannerType: HomePageBannerType.DefaultVtmGoPlus,
    },
    nieuws: {
        backgroundColor: "#10135D",
        title: "We zijn er voor u",
        description: "Nieuws van de dag met achtergrondinformatie, gevolgd door uitgebreide sportverslaggeving.",
        cta: {
            url: "/vtm-nieuws",
            label: "Meer info",
        },
        mobileImage: {
            __typename: "Image",
            id: 123,
            urls: {
                webp: "/images/banner/vtm-nieuws-default-mobile-2024.webp",
                jpeg: "/images/banner/vtm-nieuws-default-mobile-2024.jpeg",
            },
            x: 0.95,
            y: 0.15,
        },
        image: {
            __typename: "Image",
            id: 123,
            urls: {
                webp: "/images/banner/vtm-nieuws-default-2024.webp",
                jpeg: "/images/banner/vtm-nieuws-default-2024.png",
            },
            x: 0.95,
            y: 0.15,
        },
        bannerType: HomePageBannerType.News,
        channel: Channel.Vtm,
        uuid: "default-nieuws",
    },
};
